import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RAGCatalog from "@/pages/rag/RAGCatalog";
import RAGClassDetail from "@/pages/rag/RAGClassDetail";
import RAGDetail from "@/pages/rag/RAGDetail";
import RAGs from "@/pages/rag/RAGs";



// TODO(perf): RAGs is a non-first-screen page and should use React.lazy with a shared,
// accessible Suspense fallback after the chunk-loading UX is implemented.
export const ragLegacyRedirectRoutes: RouteObject[] = [
  {
    path: "/plugins/rags",
    element: <Navigate to="/plugins/rags/build" replace />,
  },
  {
    path: "/plugins/rags/collections",
    element: <Navigate to="/plugins/rags/build" replace />,
  },
  {
    path: "/plugins/rags/management",
    element: <Navigate to="/plugins/rags/build" replace />,
  },
];

export const ragRoutes: RouteObject[] = [
  {
    path: "/plugins/rags/build",
    element: <RAGs />,
  },
  {
    path: "/plugins/rags/catalog",
    element: <RAGCatalog />,
  },
  {
    path: "/plugins/rags/group-classes/:id",
    element: <RAGClassDetail />,
  },
  {
    path: "/plugins/rags/groups/:id",
    element: <RAGDetail />,
  },
];
